export const validateRepoOrBranchName = (name: string) => {
  // Validate branch name format: only allow letters, numbers, hyphens, and underscores
  const validBranchNameRegex = /^[a-zA-Z0-9_-]+$/;

  if (!validBranchNameRegex.test(name)) {
    return false;
  }

  return true;
};
